import { useEffect } from 'react';

export default function useBeforeUnload(active) {
  useEffect(() => {
    if (!active) {
      return;
    }
    const handleBeforeUnload = (e) => {
      if (!window.confirm()) {
        e.preventDefault();
        e.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [active]);
}
